import React from 'react';
import type { StageSize } from '../../../../types/canvas.types';
import { Html } from 'react-konva-utils';
import { FaArrowRotateRight } from 'react-icons/fa6';
import { CanvasButton } from './CanvasButton';
import { FaArrowRotateLeft } from 'react-icons/fa6';

interface CanvasRotationControlsProps {
  stageSize: StageSize;
  handleRotate: (rotation: number) => void;
}

const CanvasRotationControls: React.FC<CanvasRotationControlsProps> = ({
  stageSize,
  handleRotate,
}) => {
  return (
    <Html
      transformFunc={(attrs) => ({
        ...attrs,
        x: 14,
        y: stageSize.height - 54,
      })}
    >
      <div className="flex flex-col items-center" id="canvas-rotation-controls">
        <div className="flex gap-x-2">
          <CanvasButton
            icon={<FaArrowRotateLeft className="text-xl sm:text-lg" />}
            tooltipContent="Tourner le document vers la gauche (L)"
            tooltipPlace="top"
            onClick={() => handleRotate(-90)}
          />
          <CanvasButton
            icon={<FaArrowRotateRight className="text-xl sm:text-lg" />}
            tooltipContent="Tourner le document vers la droite (R)"
            tooltipPlace="top"
            onClick={() => handleRotate(90)}
          />
        </div>
      </div>
    </Html>
  );
};

export default CanvasRotationControls;
